// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yp6re","title":"styles_title__5ycNV"};